(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["cart-shipping-estimate-instant"] && !Shopify.designMode) return;
  try {
    class ShippingEstimateInstant extends HTMLElement {
    connectedCallback() {
      this.row = this.querySelector('[data-shipping-row]');
      this.valueEl = this.querySelector('[data-shipping-value]');

      this.cartUrl = this.dataset.cartUrl || '/cart';
      this.country = (this.dataset.country || '').toUpperCase();
      this.currency = this.dataset.currency || 'EUR';
      this.shopCurrency = this.dataset.shopCurrency || this.currency;
      this.locale = this.dataset.locale || 'en';
      this.freeText = this.dataset.freeText || 'Free!';
      this.itemCount = Number(this.dataset.itemCount) || 0;

      this.defaultThreshold = this.toCents(this.dataset.defaultThreshold);
      this.defaultFee = this.toCents(this.dataset.defaultFee);
      this.overrides = this.parseOverrides(this.dataset.overrides);

      this.formatter = new Intl.NumberFormat(this.locale, {
        style: 'currency',
        currency: this.currency,
      });

      // Don't read the total from the AJAX Cart API (/cart.js, /cart/change.js):
      // it does NOT apply automatic/cart-level discounts to total_price, so after a
      // cart update this row would jump to the undiscounted total (showing "Free!"
      // too early). The drawer rebuild swaps in server-rendered markup
      // (cart.ajax-drawer.liquid) whose .cart__items[data-cart-subtotal] IS the real,
      // discount-applied total — the same value the subtotal row trusts. Watch that
      // node and render against it.
      const setup = () => {
        const scope = this.closest('form') || document;
        this.productsEl = scope.querySelector('[data-products]');
        if (!this.productsEl) return;
        this._observer = new MutationObserver(() => this.syncFromDom());
        this._observer.observe(this.productsEl, { childList: true });
        this.syncFromDom();
      };
      if (document.readyState === 'loading') {
        document.addEventListener('DOMContentLoaded', setup, { once: true });
      } else {
        setup();
      }

      this.render(Number(this.dataset.cartTotal) || 0);
    }

    disconnectedCallback() {
      if (this._observer) this._observer.disconnect();
    }

    syncFromDom() {
      const itemsEl =
        this.productsEl && this.productsEl.querySelector('.cart__items[data-cart-subtotal]');
      if (!itemsEl) return;
      const total = parseInt(itemsEl.dataset.cartSubtotal, 10);
      const count = parseInt(itemsEl.dataset.count, 10);
      if (!isNaN(count)) this.itemCount = count;
      if (!isNaN(total)) this.render(total);
    }

    toCents(value) {
      if (value == null || value === '') return null;
      const amount = parseFloat(String(value).replace(',', '.'));
      return isNaN(amount) ? null : Math.round(amount * 100);
    }

    // Overrides come from a textarea, one rule per line:
    //   GB | 42.99 | 4.23   ->  country | free threshold | flat fee
    parseOverrides(raw) {
      const map = {};
      if (!raw) return map;
      raw.split('\n').forEach((line) => {
        const parts = line.split('|').map((part) => part.trim());
        const code = (parts[0] || '').toUpperCase();
        if (!code) return;
        map[code] = {
          threshold: this.toCents(parts[1]),
          fee: this.toCents(parts[2]),
        };
      });
      return map;
    }

    // A market is only safe to show a number for when its rule is denominated
    // in the currency the customer sees: either an explicit override, or the
    // default rule when the market prices in the store's own currency.
    ruleFor(country) {
      const override = this.overrides[country];
      if (override) return override;
      if (this.currency === this.shopCurrency) {
        return { threshold: this.defaultThreshold, fee: this.defaultFee };
      }
      return null;
    }

    render(totalCents) {
      this.dataset.cartTotal = totalCents;

      const rule = this.ruleFor(this.country);

      if (!this.itemCount || this.itemCount < 1 || !rule) {
        this.hide();
        return;
      }

      const feeCents = rule.fee != null ? rule.fee : 0;
      const isFree =
        feeCents <= 0 || (rule.threshold != null && rule.threshold > 0 && totalCents >= rule.threshold);

      this.row.hidden = false;

      if (isFree) {
        this.classList.add('cart-shipping-estimate--free');
        this.valueEl.textContent = this.freeText;
      } else {
        this.classList.remove('cart-shipping-estimate--free');
        this.valueEl.textContent = this.formatter.format(feeCents / 100);
      }
    }

    hide() {
      this.row.hidden = true;
      this.classList.remove('cart-shipping-estimate--free');
    }
  }

  customElements.define('shipping-estimate-instant', ShippingEstimateInstant);
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["cart-shipping-estimate-live"] && !Shopify.designMode) return;
  try {
    class ShippingEstimateLive extends HTMLElement {
    connectedCallback() {
      this.row = this.querySelector('[data-shipping-row]');
      this.valueEl = this.querySelector('[data-shipping-value]');

      const base = this.dataset.cartUrl || '/cart';
      this.prepareUrl = base + '/prepare_shipping_rates.json';
      this.asyncUrl = base + '/async_shipping_rates.json';

      this.country = (this.dataset.country || '').toUpperCase();
      // Shopify's Ajax shipping-rates API returns each rate's `price` in the
      // SHOP currency (what shipping is actually charged in), not the cart's
      // presentment currency — so the rate's own `currency` field is the source
      // of truth. Fall back to the shop currency when the API leaves it null
      // (it does so when the rate currency equals the shop currency).
      this.shopCurrency = this.dataset.shopCurrency || 'EUR';
      this.locale = this.dataset.locale || 'en';
      this.freeText = this.dataset.freeText || 'Free!';
      this.calculatingText = this.dataset.calculatingText || '';
      this.itemCount = Number(this.dataset.itemCount) || 0;

      this._formatters = {};

      this._token = 0;
      this._debounce = null;

      this._onCartUpdated = (event) => {
        const cart = event.detail && event.detail.cart;
        if (cart && typeof cart.item_count === 'number') {
          this.itemCount = cart.item_count;
        }
        this.schedule();
      };
      this._onProductAdded = () => {
        if (this.itemCount < 1) this.itemCount = 1;
        this.schedule();
      };

      document.addEventListener('cart:updated', this._onCartUpdated);
      document.addEventListener('ajaxProduct:added', this._onProductAdded);

      this.estimate();
    }

    disconnectedCallback() {
      document.removeEventListener('cart:updated', this._onCartUpdated);
      document.removeEventListener('ajaxProduct:added', this._onProductAdded);
      clearTimeout(this._debounce);
    }

    // Coalesce rapid cart changes (e.g. several quantity clicks) into one call.
    schedule() {
      clearTimeout(this._debounce);
      this._debounce = setTimeout(() => this.estimate(), 300);
    }

    async estimate() {
      const destination = this.destinationFor(this.country);

      // Shopify rejects an address it can't validate (422). Most destinations
      // need a postal code — and for some, a province — before it will return
      // rates, so only call the API when we can build a usable address.
      if (!this.itemCount || this.itemCount < 1 || !destination) {
        this.hide();
        return;
      }

      const token = ++this._token;
      this.showLoading();

      try {
        const rates = await this.fetchRates(destination);
        if (token !== this._token) return; // a newer estimate superseded this one
        this.renderRates(rates);
      } catch (error) {
        if (token === this._token) this.hide();
      }
    }

    // A representative, valid-format address per country. The specific postal
    // code doesn't change zone-based rates (flat rate / free over a threshold),
    // it just lets Shopify accept the destination and return them.
    destinationFor(code) {
      const entry = ShippingEstimateLive.POSTAL_CODES[code];
      if (!entry) return null;
      return { country: code, zip: entry.zip, province: entry.province || '' };
    }

    buildQuery(destination) {
      const params = new URLSearchParams();
      params.append('shipping_address[country]', destination.country);
      if (destination.zip) params.append('shipping_address[zip]', destination.zip);
      if (destination.province) {
        params.append('shipping_address[province]', destination.province);
      }
      return params.toString();
    }

    async fetchRates(destination) {
      const query = this.buildQuery(destination);

      // Kick off the calculation. The endpoint returns null and does the work
      // server-side, so a non-2xx here means the destination was rejected.
      const prepared = await fetch(this.prepareUrl + '?' + query, {
        method: 'POST',
        credentials: 'same-origin',
        headers: { 'Content-Type': 'application/json' },
      });
      if (!prepared.ok) return [];

      // Poll until the rates are ready (async endpoint returns null meanwhile).
      for (let attempt = 0; attempt < 12; attempt++) {
        const response = await fetch(this.asyncUrl + '?' + query, {
          credentials: 'same-origin',
        });
        if (response.ok) {
          const data = await response.json();
          if (data && data.shipping_rates) return data.shipping_rates;
        }
        await this.delay(500);
      }
      return [];
    }

    renderRates(rates) {
      if (!rates || !rates.length) {
        this.hide();
        return;
      }

      // The cheapest available rate is the one the customer will realistically
      // pay, and it's what turns into "Free!" once a threshold is met.
      const cheapest = rates.reduce((lowest, rate) => {
        const price = parseFloat(rate.price);
        return lowest === null || price < lowest.price
          ? { price: price, currency: rate.currency }
          : lowest;
      }, null);

      const cents = Math.round((cheapest ? cheapest.price : 0) * 100);

      this.row.hidden = false;
      this.classList.remove('cart-shipping-estimate--loading');

      if (cents <= 0) {
        this.classList.add('cart-shipping-estimate--free');
        this.valueEl.textContent = this.freeText;
      } else {
        this.classList.remove('cart-shipping-estimate--free');
        // Format in the rate's own currency (the shop currency the amount is
        // billed in), not the cart's presentment currency.
        const currency = (cheapest && cheapest.currency) || this.shopCurrency;
        this.valueEl.textContent = this.formatterFor(currency).format(cents / 100);
      }
    }

    // Cache one Intl formatter per currency code seen.
    formatterFor(currency) {
      if (!this._formatters[currency]) {
        this._formatters[currency] = new Intl.NumberFormat(this.locale, {
          style: 'currency',
          currency: currency,
        });
      }
      return this._formatters[currency];
    }

    showLoading() {
      if (!this.calculatingText) return; // avoid a flash when there's no copy
      this.row.hidden = false;
      this.classList.add('cart-shipping-estimate--loading');
      this.classList.remove('cart-shipping-estimate--free');
      this.valueEl.textContent = this.calculatingText;
    }

    hide() {
      this.row.hidden = true;
      this.classList.remove('cart-shipping-estimate--free', 'cart-shipping-estimate--loading');
    }

    delay(ms) {
      return new Promise((resolve) => setTimeout(resolve, ms));
    }
  }

  // Capital / major-city postal codes (and province where required) used only
  // to satisfy address validation so zone-based rates come back. Extend this if
  // you ship to countries not listed here.
  ShippingEstimateLive.POSTAL_CODES = {
    AT: { zip: '1010' },
    BE: { zip: '1000' },
    BG: { zip: '1000' },
    HR: { zip: '10000' },
    CY: { zip: '1010' },
    CZ: { zip: '11000' },
    DK: { zip: '1050' },
    EE: { zip: '10111' },
    FI: { zip: '00100' },
    FR: { zip: '75001' },
    DE: { zip: '10115' },
    GR: { zip: '10431' },
    HU: { zip: '1051' },
    IE: { zip: 'D01 F5P2' },
    IT: { zip: '00118' },
    LV: { zip: 'LV-1010' },
    LT: { zip: '01100' },
    LU: { zip: '1009' },
    MT: { zip: 'VLT 1010' },
    NL: { zip: '1011 AA' },
    PL: { zip: '00-001' },
    PT: { zip: '1000-001' },
    RO: { zip: '010011' },
    SK: { zip: '81101' },
    SI: { zip: '1000' },
    ES: { zip: '28001' },
    SE: { zip: '111 20' },
    GB: { zip: 'SW1A 1AA' },
    CH: { zip: '8001' },
    NO: { zip: '0001' },
    IS: { zip: '101' },
    LI: { zip: '9490' },
    US: { zip: '10001', province: 'New York' },
    CA: { zip: 'M5V 3L9', province: 'Ontario' },
    AU: { zip: '2000', province: 'New South Wales' },
  };

  customElements.define('shipping-estimate-live', ShippingEstimateLive);
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["free-gift-offer"] && !Shopify.designMode) return;
  try {
    class FreeGiftOffer extends HTMLElement {
    connectedCallback() {
      this.threshold = Number(this.dataset.threshold) || 0;
      this.cartUrl = this.dataset.cartUrl;
      this.count = Number(this.dataset.count) || 0;
      this.titleLocked = this.dataset.titleLocked || '';
      this.titleUnlocked = this.dataset.titleUnlocked || '';
      this.btnLocked = this.dataset.btnLocked || 'Gesperrt';
      this.btnUnlocked = this.dataset.btnUnlocked || '+ Hinzufügen';
      this.heading = this.querySelector('[data-gift-heading]');
      this.buttons = Array.from(this.querySelectorAll('[data-picker-open]'));
      this.labels = Array.from(this.querySelectorAll('[data-gift-btn-label]'));
      this.formatter = new Intl.NumberFormat(this.dataset.locale || 'en', {
        style: 'currency',
        currency: this.dataset.currency,
      });
      this._removing = false;

      this._onCart = this.refresh.bind(this);
      document.addEventListener('cart:updated', this._onCart);
      document.addEventListener('ajaxProduct:added', this._onCart);

      // Qualify against the real, discount-applied total — NOT the AJAX Cart API
      // sum of final_line_price, which ignores automatic/cart-level discounts and
      // would keep the offer unlocked below the threshold whenever a cart discount
      // (e.g. a bundle deal) is active. The drawer rebuild swaps in server-rendered
      // markup whose .cart__items[data-cart-subtotal] IS that discounted total — the
      // same node the shipping bar trusts. Watch it and re-qualify on every rebuild;
      // the event above fires before the DOM swap, so the observer is what makes the
      // number reliable.
      const setup = () => {
        const scope = this.closest('form') || document;
        this.productsEl = scope.querySelector('[data-products]');
        if (!this.productsEl) return;
        this._observer = new MutationObserver(() => this.refresh());
        this._observer.observe(this.productsEl, { childList: true });
      };
      if (document.readyState === 'loading') {
        document.addEventListener('DOMContentLoaded', setup, { once: true });
      } else {
        setup();
      }

      // Opening the picker is `product-picker-drawer`'s job — it delegates off
      // each card's `[data-picker-open]` button. Below the threshold the buttons
      // are disabled, so they emit no click and the gift stays locked.
      this.refresh();
    }

    disconnectedCallback() {
      document.removeEventListener('cart:updated', this._onCart);
      document.removeEventListener('ajaxProduct:added', this._onCart);
      if (this._observer) this._observer.disconnect();
    }

    // Real, discount-applied cart total in cents, scraped from the rebuilt drawer
    // markup. Returns null before the first rebuild, so callers can fall back.
    discountedTotal() {
      const el =
        this.productsEl &&
        this.productsEl.querySelector('.cart__items[data-cart-subtotal]');
      if (!el) return null;
      const cents = parseInt(el.dataset.cartSubtotal, 10);
      return isNaN(cents) ? null : cents;
    }

    isGiftLine(item) {
      const props = item.properties || {};
      return props._free_gift === 'true' || props._free_gift === true;
    }

    refresh() {
      fetch(this.cartUrl, { credentials: 'same-origin' })
        .then((response) => response.json())
        .then((cart) => this.render(cart))
        .catch(() => {});
    }

    render(cart) {
      const items = cart.items || [];
      const giftLine = items.find((item) => this.isGiftLine(item));
      // Prefer the discount-applied drawer total. The free gift is free, so it adds
      // ~0 to that total and needs no separate exclusion. Fall back to summing the
      // AJAX line prices only before the first rebuild, when the DOM total isn't up
      // yet (undiscounted, but self-corrects on the next rebuild).
      const discountedTotal = this.discountedTotal();
      const qualifyingTotal =
        discountedTotal !== null
          ? discountedTotal
          : items.reduce(
              (sum, item) =>
                this.isGiftLine(item) ? sum : sum + item.final_line_price,
              0
            );
      const qualifies = qualifyingTotal >= this.threshold;

      if (giftLine) {
        // Gift already in cart. Auto-remove if the cart no longer qualifies,
        // otherwise hide the offer (one gift per cart).
        if (!qualifies && !this._removing) {
          this._removing = true;
          theme.cart
            .changeItem(giftLine.key, 0)
            .then(() => {
              this._removing = false;
              document.dispatchEvent(new CustomEvent('cart:build'));
              this.refresh();
            })
            .catch(() => {
              this._removing = false;
            });
          return;
        }
        this.hidden = true;
        return;
      }

      this.hidden = false;
      this.classList.toggle('cd-gift-offer--unlocked', qualifies);

      if (this.heading) {
        this.heading.textContent = qualifies ? this.titleUnlocked : this.titleLocked;
      }

      const remaining = this.formatter.format(
        Math.max(0, this.threshold - qualifyingTotal) / 100
      );
      const lockedLabel =
        this.btnLocked.indexOf('[remaining]') !== -1
          ? this.btnLocked.replace('[remaining]', remaining)
          : this.btnLocked;

      this.buttons.forEach((btn) => (btn.disabled = !qualifies));
      this.labels.forEach((label) => {
        label.textContent = qualifies ? this.btnUnlocked : lockedLabel;
      });
    }
  }

  customElements.define('free-gift-offer', FreeGiftOffer);
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["product-picker-drawer"] && !Shopify.designMode) return;
  try {
    class ProductPickerDrawer extends HTMLElement {
    connectedCallback() {
      this.addUrl = this.dataset.cartAdd;
      this.scroll = this.querySelector('[data-picker-scroll]');
      this.heading = this.querySelector('[data-picker-heading]');
      this.form = this.querySelector('[data-picker-form]');
      this.variantInput = this.querySelector('[data-picker-variant-input]');
      this.propertiesHost = this.querySelector('[data-picker-properties]');
      this.addBtn = this.querySelector('[data-picker-add]');
      this.addLabel = this.querySelector('[data-picker-add-label]');
      this.deliveryNote = this.querySelector('[data-picker-delivery]');

      // Delegated so cards rendered after page load (cart recommendations are
      // re-fetched on every cart change) work without re-binding.
      this._onTriggerClick = (evt) => {
        const trigger = evt.target.closest && evt.target.closest('[data-picker-open]');
        if (!trigger) return;
        const host = trigger.closest('[data-picker-host]');
        const template = host && host.querySelector('template[data-picker-template]');
        if (!template) return;
        this.open(template);
      };
      document.addEventListener('click', this._onTriggerClick);

      // The cart drawer closes itself on any bubble-phase click/keyup that
      // reaches `window` from outside a `.drawer`. This picker sits above the
      // cart drawer but isn't a `.drawer`, so stop its events from bubbling to
      // `window` — otherwise closing (or even tapping) the picker also closes
      // the cart drawer.
      this.addEventListener('click', (evt) => evt.stopPropagation());

      this.querySelectorAll('[data-picker-close]').forEach((el) =>
        el.addEventListener('click', () => this.close())
      );

      // Swatches arrive with the cloned template, so listen on the container.
      this.scroll.addEventListener('click', (evt) => {
        const swatch = evt.target.closest('.cd-picker__swatch');
        if (!swatch || swatch.dataset.available !== 'true') return;
        this.applyVariant(swatch);
      });

      // Capture-phase on window: while the picker is open, Escape must not reach
      // the cart drawer (or any other drawer). Every drawer's close() removes the
      // shared `js-drawer-open` class from <html>, which hides all the cart
      // drawer's `.appear-animation` content (blanks it out). stopImmediatePropagation
      // halts the event before any of those handlers run; we close only the picker.
      this._onEsc = (evt) => {
        if (evt.key !== 'Escape') return;
        evt.stopImmediatePropagation();
        if (evt.type === 'keyup') this.close();
      };

      this.form.addEventListener('submit', this.addToCart.bind(this));
    }

    disconnectedCallback() {
      document.removeEventListener('click', this._onTriggerClick);
      window.removeEventListener('keydown', this._onEsc, true);
      window.removeEventListener('keyup', this._onEsc, true);
    }

    open(template) {
      this.scroll.innerHTML = '';
      this.scroll.appendChild(template.content.cloneNode(true));

      this.activeProduct = this.scroll.querySelector('[data-picker-product]');
      if (!this.activeProduct) return;

      this.heading.textContent = template.dataset.pickerName || '';

      // Same labels as the product page's add-to-cart button.
      this.addLabelText = template.dataset.pickerAddLabel || '';
      this.soldOutLabelText = template.dataset.pickerSoldOutLabel || this.addLabelText;

      const delivery = template.dataset.pickerDelivery || '';
      this.deliveryNote.textContent = delivery ? '● ' + delivery : '';
      this.deliveryNote.hidden = !delivery;

      this.setProperties(template.dataset.pickerProperties);

      const active = this.activeProduct.querySelector('.cd-picker__swatch.is-active');
      if (active) {
        this.applyVariant(active);
      } else {
        this.variantInput.value = this.activeProduct.dataset.defaultVariant || '';
        this.setAvailable(this.activeProduct.dataset.defaultAvailable === 'true');
      }

      const gallery = this.activeProduct.querySelector('[data-picker-gallery]');
      const counter = gallery && gallery.querySelector('[data-picker-counter]');
      if (counter) {
        gallery.addEventListener('scroll', () => this.updateCounter(gallery, counter));
      }

      this.scroll.scrollTop = 0;

      this.hidden = false;
      void this.offsetWidth; // reflow so the transition runs
      this.classList.add('is-open');

      // Intercept Escape before any drawer/handler can react to it.
      window.addEventListener('keydown', this._onEsc, true);
      window.addEventListener('keyup', this._onEsc, true);
    }

    close() {
      this.classList.remove('is-open');
      window.removeEventListener('keydown', this._onEsc, true);
      window.removeEventListener('keyup', this._onEsc, true);
      window.setTimeout(() => {
        this.hidden = true;
        this.scroll.innerHTML = '';
        this.activeProduct = null;
      }, 300);
    }

    // Line-item properties the caller wants on the line, e.g. {"_free_gift":"true"}.
    setProperties(json) {
      this.propertiesHost.innerHTML = '';
      let properties = {};
      try {
        properties = JSON.parse(json || '{}');
      } catch (e) {
        return;
      }
      Object.keys(properties).forEach((key) => {
        const input = document.createElement('input');
        input.type = 'hidden';
        input.name = 'properties[' + key + ']';
        input.value = properties[key];
        this.propertiesHost.appendChild(input);
      });
    }

    applyVariant(swatch) {
      this.activeProduct
        .querySelectorAll('.cd-picker__swatch')
        .forEach((el) => el.classList.remove('is-active'));
      swatch.classList.add('is-active');

      this.variantInput.value = swatch.dataset.variantId;
      this.setAvailable(swatch.dataset.available === 'true');

      const label = this.activeProduct.querySelector('[data-picker-variant-label]');
      if (label) label.textContent = swatch.dataset.variantTitle;

      this.updatePrice(swatch);
    }

    setAvailable(available) {
      this.addBtn.disabled = !available;
      this.addLabel.textContent = available ? this.addLabelText : this.soldOutLabelText;
    }

    // Keep in sync with `product-price-line.liquid` — same markup, so the picker
    // and the cart line items stay identical. A free gift's price block is
    // struck-through + GRATIS whatever the variant, so leave it alone.
    updatePrice(swatch) {
      if (this.activeProduct.dataset.free === 'true') return;
      const price = this.activeProduct.querySelector('[data-picker-price]');
      if (!price || !swatch.dataset.variantPrice) return;

      if (swatch.dataset.variantHasCompare === 'true') {
        const discount = Number(swatch.dataset.variantDiscount) || 0;
        price.innerHTML =
          '<span class="cd-item__price-was">' + swatch.dataset.variantCompareAtPrice + '</span>' +
          '<span class="cd-item__price-now">' + swatch.dataset.variantPrice + '</span>' +
          (discount > 0 ? '<span class="cd-item__badge">-' + discount + '%</span>' : '');
      } else {
        price.innerHTML =
          '<span class="cd-item__price-now cd-item__price-now--plain">' +
          swatch.dataset.variantPrice +
          '</span>';
      }
    }

    updateCounter(gallery, counter) {
      const width = gallery.clientWidth || 1;
      const index = Math.round(gallery.scrollLeft / width) + 1;
      const total = gallery.querySelectorAll('.cd-picker__slide').length;
      counter.textContent = index + ' / ' + total;
    }

    addToCart(evt) {
      evt.preventDefault();
      if (this.addBtn.disabled || !this.variantInput.value) return;
      this.addBtn.classList.add('btn--loading');

      fetch(this.addUrl, {
        method: 'POST',
        body: new FormData(this.form),
        credentials: 'same-origin',
        headers: { 'X-Requested-With': 'XMLHttpRequest' },
      })
        .then((response) => response.json())
        .then((product) => {
          this.addBtn.classList.remove('btn--loading');
          if (product && product.status && product.status !== 200) return;
          // Rebuilds + opens the cart drawer, and refreshes the offer card.
          document.dispatchEvent(
            new CustomEvent('ajaxProduct:added', {
              detail: { product: product },
              bubbles: true,
            })
          );
          this.close();
        })
        .catch(() => {
          this.addBtn.classList.remove('btn--loading');
        });
    }
  }

  customElements.define('product-picker-drawer', ProductPickerDrawer);
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["shipping-progress-bar"] && !Shopify.designMode) return;
  try {
    class ShippingProgressBar extends HTMLElement {
    connectedCallback() {
      this.messageEl = this.querySelector('[data-shipping-bar-message]');
      this.fillEl = this.querySelector('[data-shipping-bar-fill]');
      this.mode = this.dataset.mode;
      this.shippingThreshold = Number(this.dataset.shippingThreshold) || 0;
      this.giftThreshold = Number(this.dataset.giftThreshold) || 0;
      this.finalThreshold = Number(this.dataset.finalThreshold) || 0;
      this.formatter = new Intl.NumberFormat(this.dataset.locale || 'en', {
        style: 'currency',
        currency: this.dataset.currency,
      });

      // Don't read the total from the AJAX Cart API (/cart.js, /cart/change.js):
      // it does NOT apply automatic/cart-level discounts to total_price, so after a
      // cart update the bar would jump to the undiscounted total. The drawer rebuild
      // swaps in server-rendered markup (cart.ajax-drawer.liquid) whose
      // .cart__items[data-cart-subtotal] IS the real, discount-applied total — the
      // same value the subtotal row trusts. Watch that node and render against it.
      const setup = () => {
        const scope = this.closest('form') || document;
        this.productsEl = scope.querySelector('[data-products]');
        if (!this.productsEl) return;
        this._observer = new MutationObserver(() => this.syncFromDom());
        this._observer.observe(this.productsEl, { childList: true });
        this.syncFromDom();
      };
      if (document.readyState === 'loading') {
        document.addEventListener('DOMContentLoaded', setup, { once: true });
      } else {
        setup();
      }

      this.render(Number(this.dataset.cartTotal) || 0);
    }

    disconnectedCallback() {
      if (this._observer) this._observer.disconnect();
    }

    syncFromDom() {
      const itemsEl =
        this.productsEl && this.productsEl.querySelector('.cart__items[data-cart-subtotal]');
      if (!itemsEl) return;
      const total = parseInt(itemsEl.dataset.cartSubtotal, 10);
      if (!isNaN(total)) this.render(total);
    }

    formatMoney(cents) {
      return this.formatter.format(cents / 100);
    }

    render(totalCents) {
      this.dataset.cartTotal = totalCents;

      const percent =
        this.finalThreshold > 0 ? Math.min(100, (totalCents / this.finalThreshold) * 100) : 100;
      this.fillEl.style.width = percent + '%';

      const shippingUnlocked = totalCents >= this.shippingThreshold;
      const giftUnlocked = this.mode === 'shipping_gift' && totalCents >= this.giftThreshold;

      this.classList.toggle('shipping-bar--shipping-unlocked', shippingUnlocked);
      this.classList.toggle(
        'shipping-bar--complete',
        this.mode === 'shipping_gift' ? giftUnlocked : shippingUnlocked
      );

      let message;

      if (!shippingUnlocked) {
        message = this.dataset.msgSpendShipping.replace(
          '[amount]',
          `<strong>${this.formatMoney(this.shippingThreshold - totalCents)}</strong>`
        );
      } else if (this.mode === 'shipping_gift' && !giftUnlocked) {
        message = this.dataset.msgSpendGift.replace(
          '[amount]',
          `<strong>${this.formatMoney(this.giftThreshold - totalCents)}</strong>`
        );
      } else if (this.mode === 'shipping_gift') {
        message = this.dataset.msgGiftUnlocked;
      } else {
        message = this.dataset.msgShippingUnlocked;
      }

      this.messageEl.innerHTML = message;
    }
  }

  customElements.define('shipping-progress-bar', ShippingProgressBar);
  } catch(e) { console.error(e); }
})();

})();
